/**
 * Analytics — a **vendor-agnostic facade over one injected port**.
 *
 * App code imports the functions (`trackEvent`, `logError`, …) exactly as before and does
 * not know or care who is on the other end. `OnboardingRoot` publishes that port from its
 * `analytics` prop: standalone it is our own adapter
 * (`#modules/vidaVendors`), which builds PostHog + Datadog from
 * `EXPO_PUBLIC_*`; embedded it is the host's, so onboarding events land on the host's
 * identity and Datadog service instead of splitting one user in two.
 *
 * Nothing in this module imports a vendor SDK — that is the invariant
 * `src/packaging.test.ts` enforces, and the reason this graph can be published. See
 * `docs/vendor-ownership-proposal.md`.
 *
 * **No React component lives here either.** The router → `trackScreen` bridge used to, as
 * `AnalyticsProvider`, and its `expo-router` import was this module's only framework
 * dependency; it is now `root`'s `ScreenViewTracker`, mounted by `OnboardingRoot` and switched
 * by its `trackScreens` prop (unchanged for callers). What remains is the port, a facade over
 * it, and a flag hook — external surface `react` plus `User`, which is what makes this
 * module publishable once its two `@/types/user` specifiers become `#types/user`.
 */
export * from './hooks/useFeatureFlag';
export * from './utils/analytics'; // includes setAnalytics / getAnalytics / resetAnalytics
export type { AnalyticsPort, AppOpenSource } from './types/analyticsPort';
export type { OnboardingVendors } from './types/onboardingVendors';
